import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Reveal, Wrap } from "./Motion";

const inputCls = "w-full bg-transparent border-b border-white/20 focus:border-[#D4AF37] outline-none py-3 text-base text-[#F8F6F0] placeholder:text-[#6F7C97] transition-colors";

export const VipCapture = () => {
  const [form, setForm] = useState({ name: "", email: "", country: "", interest: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await api.post("/leads", form); setDone(true); toast.success(r.data.message); }
    catch (err) { const d = err.response?.data?.detail; toast.error(Array.isArray(d) ? d.map((x) => x.msg).join(" ") : d || "Something went wrong"); }
    finally { setBusy(false); }
  };

  return (
    <section id="vip" className="relative py-20 lg:py-36 overflow-hidden bg-[#0F1D3D]" data-testid="vip-section">
      <div className="absolute inset-0 spotlight" />
      <Wrap className="relative grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-6">
          <Reveal><p className="eyebrow mb-4">Private catalogue · 2026</p></Reveal>
          <Reveal delay={0.08}><h2 className="font-display text-balance text-3xl sm:text-4xl lg:text-6xl text-[#F8F6F0] leading-[1]">See the 2026 lots before they're public.</h2></Reveal>
          <Reveal delay={0.16}><p className="mt-4 text-sm sm:text-base text-[#AEB7C9] max-w-md leading-relaxed">Vet reports, ridden videos and Greg's assessments reach our private list two weeks early. Tell us your level and we'll shortlist for you.</p></Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5 lg:col-start-8">
          {done ? (
            <div className="border border-[#D4AF37]/30 p-8 h-full flex flex-col justify-center" data-testid="vip-success">
              <p className="eyebrow">You're on the list</p>
              <p className="mt-3 font-display text-3xl text-[#F8F6F0]">Welcome to Ballypatrick.</p>
              <p className="mt-2 text-sm text-[#AEB7C9]">The private 2026 catalogue will reach you first.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-6" data-testid="vip-form">
              <input required placeholder="Full name" autoComplete="name" className={inputCls} value={form.name} onChange={set("name")} data-testid="ballypatrick-vip-name-input" />
              <input required type="email" placeholder="Email address" autoComplete="email" className={inputCls} value={form.email} onChange={set("email")} data-testid="ballypatrick-vip-email-input" />
              <input placeholder="Country" autoComplete="country-name" className={inputCls} value={form.country} onChange={set("country")} data-testid="ballypatrick-vip-country-input" />
              <select className={`${inputCls} bg-[#0F1D3D]`} value={form.interest} onChange={set("interest")} data-testid="ballypatrick-vip-interest-select">
                <option value="">I'm buying for…</option>
                <option>1.50m+ Grand Prix Prospect</option>
                <option>1.30m–1.40m Young Rider / U25</option>
                <option>1.20m–1.30m Amateur / Junior</option>
                <option>148cm Pony Championship</option>
                <option>Future Investment · 3yo</option>
                <option>Hunter / Equitation (USA)</option>
              </select>
              <button type="submit" disabled={busy} className="btn-gold w-full disabled:opacity-60" data-testid="ballypatrick-vip-submit-btn">{busy ? "Sending…" : "Request private access"} <ArrowUpRight size={14} /></button>
              <p className="text-xs text-[#6F7C97]">One catalogue, a handful of updates. No spam.</p>
            </form>
          )}
        </Reveal>
      </Wrap>
    </section>
  );
};
